
    import {Component, Vue} from "vue-property-decorator";

    @Component({
        components: {
        },
    })
    export default class FileDragAndDrop extends Vue {
        dragover = false;
        uploadedFiles = [];
        multiple = true;
        fileToUpload = null;

        onPickFile () {
            document.getElementById("fileInput").click();
        }

        onFilePicked(e) {

                if (!this.multiple && this.uploadedFiles.length > 0) {
                    this.$store.dispatch("addNotification", {
                        message: "Only one file can be uploaded at a time..",
                        colour: "error"
                    });
                } else {
                    this.uploadedFiles.push(e);
                }


        }

        onDrop(e) {
            this.dragover = false;
            // Check if there are already uploaded files
            if (!this.multiple && e.dataTransfer.files.length > 1) {
                this.$store.dispatch("addNotification", {
                    message: "Only one file can be uploaded at a time..",
                    colour: "error"
                });
            } else
                e.dataTransfer.files.forEach(element =>
                    this.uploadedFiles.push(element)
                );
        }

        removeFile(fileName) {
            const index = this.uploadedFiles.findIndex(
                file => file.name === fileName
            );
            // If file is in uploaded files remove it
            if (index > -1) this.uploadedFiles.splice(index, 1);
        }

    }
